'use client'

import IMask from 'imask'
import moment from 'moment'
import React, { useState, useEffect, useRef } from 'react'

type DateProps = {
    onChange: Function,
    className?: string
}

export default function DateMask({
    value,
    onChange,
    className = ''
}) {

    const ref = useRef<HTMLInputElement>(null)    
    const refMask = useRef(null)

    useEffect(() => {
        refMask.current = IMask(ref.current, {
            mask: "00/00/0000",
            min: new Date(2024, 0, 1),
            max: new Date(2040, 0, 1),
            lazy: false,            
        })        
    }, [])

    useEffect(() => {
        if (!refMask.current) return        
        refMask.current.value = value
    }, [value])

    useEffect(() => {
        refMask.current.on('accept', (e) => {
            if (!e) return
            if (!e.target)
            if (!e.target.value) return
            if (e.target.value.length !== 10) return
            if (e.target.value === '__/__/____') {
                onChange('')
                return
            }
            if (e.target.value.indexOf('_') !== -1) return
            if (moment(e.target['value'], 'DD/MM/YYYY').isValid() === false) return
            onChange(moment(e.target['value'], 'DD/MM/YYYY').format('YYYY-MM-DD'))
        })
    }, [onChange])

    return (
        <>
            <input
                ref={ref}
                type="text"     
                defaultValue={value}    
                className={className}                       
            />
        </>
    )
}